import { createContext } from "react"
const Context = createContext("pl")

export const { Provider: LangProvider, Consumer: LangConsumer } = Context
export default Context
